module.exports = __webpack_public_path__ + "static/pk-06dbc3d7e790c874587442f062b6f961.png";